import React, { useRef, useState } from 'react';
import { Helmet } from 'react-helmet-async';



interface MetaProps {
  title: string;
  description: string;
  keywords?: string;
  canonicalUrl?: string;
  ogTitle?: string;
  ogDescription?: string;
  ogType?: string;
    ogImage?: string;
  ogUrl?: string;
  twitterCard?: string;
  twitterTitle?: string;
  twitterDescription?: string;
  twitterImage?: string;
  twitterSite?: string;
  noIndex?: boolean;
  jsonLdSchemas?: object[];
  htmlAttributes?: Record<string, string>;
  onChangeClientState?: (newState: any) => void;
  onHelmetChange?: (newState: any) => void;
}

const Meta: React.FC<MetaProps> = ({
  title,
  description,
  keywords,
  canonicalUrl,
  ogTitle,
  ogDescription,
  ogType = 'website',
    ogImage,
  ogUrl,
  twitterCard = 'summary_large_image',
  twitterTitle,
  twitterDescription,
  twitterImage,
  twitterSite,
  noIndex,
  jsonLdSchemas,
  htmlAttributes = {},
  onChangeClientState,
  onHelmetChange,
}) => {
  const prerenderStatus = useRef<'waiting' | 'ready'>('waiting');
  const [status, setStatus] = useState<'waiting' | 'ready'>('waiting');

    const finalKeywords = keywords || '';

  const handleChange = (newState: any) => {
    const hasDescription = newState.metaTags?.some(
      (tag: any) => tag.name === 'description' && tag.content
    );
    if (hasDescription) {
      prerenderStatus.current = 'ready';
      setStatus('ready');
    }
    if (onHelmetChange) onHelmetChange(newState);
  };

  const helmetProps = onChangeClientState ? { onChangeClientState } : {};

  return (
    <Helmet {...helmetProps}>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={finalKeywords} />
      {noIndex && <meta name="robots" content="noindex" />}
      {canonicalUrl && <link rel="canonical" href={canonicalUrl} />}

      <meta property="og:type" content={ogType} />
      <meta property="og:title" content={ogTitle || title} />
      <meta property="og:description" content={ogDescription || description} />
            {(ogUrl || canonicalUrl) && <meta property="og:url" content={ogUrl || canonicalUrl} />}
      {ogImage && <meta property="og:image" content={ogImage} />}

      <meta name="twitter:card" content={twitterCard} />
      <meta name="twitter:title" content={twitterTitle || ogTitle || title} />
      <meta name="twitter:description" content={twitterDescription || ogDescription || description} />
      {twitterImage && <meta name="twitter:image" content={twitterImage} />}
      {twitterSite && <meta name="twitter:site" content={twitterSite} />}

      {jsonLdSchemas?.map((schema, idx) => (
        <script
          key={`jsonld-${idx}`}
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
        />
      ))}
    </Helmet>
  );
};

export default Meta;
